
    function getTime(){
        let date = new Date();
        let hours = date.getHours().toString().padStart(2, '0');
        let minutes = date.getMinutes().toString().padStart(2, '0');
        return `${hours}:${minutes}`;
    }

    function getDayOfWeekText(date) {
        const dayOfWeek = new Date(date).getDay();    
        return isNaN(dayOfWeek) ? null : 
            ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'][dayOfWeek];
    }

    function getMonthText(date) {
        const month = new Date(date).getMonth();    
        return isNaN(month) ? null : 
            ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'][month];
    }

    function getDate(){
        let date = new Date();
        let day = date.getDate().toString().padStart(2, '0');
        let month = (date.getMonth() + 1).toString().padStart(2, '0');
        let year = date.getFullYear();
        return `${day}/${month}/${year}`;
    }

    function getDateText(){
        let date = new Date();
        let day = date.getDate().toString().padStart(2, '0');

        return `${getDayOfWeekText(date)} ${day} ${getMonthText(date)}`;
    }

export { getTime, getDate, getDateText, getDayOfWeekText, getMonthText }